import React, { useEffect, useState, memo, useRef, useMemo } from "react";
import ReactPixel from 'react-facebook-pixel';
import resumeCss from "./Resume.module.css";
// import depoCss from "../Depositions/Depositions.module.css" // legacy commented UI
import { useNavigate } from "react-router-dom";
import AuthInput from "../UI/Input/AuthInputs";
// import { Grid } from "@mui/material"; // kept for legacy commented UI
import { 
  checkAuthenticatedUser, 
  checkEmptyStringsInObj, 
  checkEmptyStringsInObjNoExempt, 
  checkEmptyStrings 
} from "../../utils/client-functions";
import { useSelector, useDispatch } from "react-redux";
import { 
  setUser, 
  setUserFirstName,
  setProfileImg,
  setResume, 
  setFetching, 
  setUserResumesAll, 
  setResumeSubDuration,
  setIsResumeSubbed,
  setHideCards,
  setResumeServicesNumbers
} from "../../redux/states";
import { useErrorSetter } from '../../hooks/useUiMessages';
import { ButtonSubmitGreen } from "../UI/Buttons/Buttons";
import axios from "axios";
import { Modal, PlainModalOverlay, SuccessFailureModal } from "../UI/Modal/Modal";
import AuthSideMenu from "../UI/AuthSideMenu/AuthSideMenu";
import AuthHeader from "../UI/AuthHeader/AuthHeader";
import { useConfirm } from "material-ui-confirm";
// import Alert from '@mui/material/Alert'; // legacy commented UI
// import CircularProgress from '@mui/material/CircularProgress';
// import Typography from '@mui/material/Typography';
// import Box from '@mui/material/Box';
// import { FaLongArrowAltRight, FaLongArrowAltLeft } from "react-icons/fa"; // legacy commented UI
// import { IoSparklesSharp } from "react-icons/io5"; // legacy commented UI
// import { TbScreenshot } from "react-icons/tb"; // legacy commented UI
// import CancelIcon from '@mui/icons-material/Cancel'; // legacy commented UI
// import uploadBtnStyles from '../UI/UploadPasteButton.module.css'; // legacy commented UI

import holisticAnalytics from '../../utils/holisticAnalytics';
import { LANGUAGES } from '../../utils/languages';
import BubbleFloat from "../UI/BubbleFloat/BubbleFloat";
import UpgradePopup from '../UI/SubscriptionPlans/UpgradePopup';
import DataContainer from "./DataContainer";
import ResumePreviewModal from "./ResumePreviewModal";
// import {OptimizeInputsContainerStyled} from "../../styled/Resume"; // legacy
const langLevelsArray = [
  {name: '1'},
  {name: '2'},
  {name: '3'},
  {name: '4'},
  {name: '5'}
]

const jobTypesArray = [
  {name: 'Hybrid'},
  {name: 'Remote'},
  {name: 'On-site'}
]

const sexOptions = [
  { mobileCode: 'male', name: 'Male' },
  { mobileCode: 'female', name: 'Female' },
  { mobileCode: 'other', name: 'Other' },
  { mobileCode: 'prefer_not_to_say', name: 'Prefer not to say' },
];



const CustomizeResume = () => {
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-new-func */
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { user, userResumesAll, isResumeSubbed } = useSelector((state) => state.stateData);
  const navigate = useNavigate();
  // const location = useLocation(); // legacy
  const dragDropRef = useRef();
  const [loading, setLoading] = useState(false);
  const [authMenuOpen, setAuthMenuOpen] = useState(false);
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [progressStatus, setProgressStatus] = useState('Creating your Resume...');
  const [isFirstTimeUserPopUp, setIsFirstTimeUserPopUp] = useState(false)
  const [dobFirstUser, setDobFirstUser] = useState("")
  const [sexFirstUser, setSexFirstUser] = useState("")
  const [mobileFirstUser, setMobileFirstUser] = useState("")
  const [subDuration, setSubDuration] = useState("");
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState(false);
  // const [creatorDisplay, setCreatorDisplay] = useState(""); // legacy selection
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [jobConnectType, setJobConnectType] = useState("Hybrid")
  const [successfulAchievement, openSuccessfulAchievement] = useState(false)
  const [bubblePoints, setBubblePoints] = useState(0)
  // Image upload/paste for additionalInfo (up to 5 images)
  const [addlInfoImagePreviews, setAddlInfoImagePreviews] = useState([]);
  const [addlInfoImageFiles, setAddlInfoImageFiles] = useState([]);
  const addlInfoFileInputRef = useRef(null);
  const [activeStoredResumeIndex, setActiveStoredResumeIndex] = useState(0);
  const [previewResume, setPreviewResume] = useState(null);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [selectedStoredResume, setSelectedStoredResume] = useState(null);
  const [selectedStoredResumeName, setSelectedStoredResumeName] = useState('');

  // const screenWidth = window.innerWidth // legacy references in commented UI
  const successfulTargetAchievement = localStorage.getItem("successfulTargetAchievement")

  const isAuth = localStorage?.getItem("token");

  const errorSetter = useErrorSetter();

  // Local cache keys and TTL
  const RESUME_LOCAL_KEY = "5787378Tgigi879889%%%%7]][][]]]=-9-0d90900io90799CVBcvVVHGGYUYFUYIOUIUTY0I9T]---000789XZJHVB[[[27627787tdtu&3$*))(990-__)((@@";
  const CAREER_ROADMAP_KEY = "careerRoadmapCache_v1";
  const CACHE_TTL_MS = 168 * 60 * 60 * 1000; // 7 days

  const setCareerRoadmapCache = (roadmap) => {
    try {
      if (!roadmap) return;
      const now = Date.now();
      const payload = { data: roadmap, expiration: now + CACHE_TTL_MS };
      localStorage?.setItem(CAREER_ROADMAP_KEY, JSON.stringify(payload));
    } catch (_) {}
  };

  const storedResumes = useMemo(() => {
    if (Array.isArray(userResumesAll)) return userResumesAll;
    if (userResumesAll && typeof userResumesAll === 'object') return Object.values(userResumesAll);
    return [];
  }, [userResumesAll]);

  // removed: checkCareerRoadmapStatus — career roadmap is now included in `/user/resume`

  //resume data
  const [basicInfo, setBasicInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    jobPosition: "",
    city: "",
    country: "",
    profSummary: "",
  });

  const advancedMatching = { 
    em: user.email
  }

  // const handleNavigateProfile = () => {
  //   const prevPath = location.pathname
  //   sessionStorage.setItem("prevPath", prevPath)
  //   navigate("/user/dashboard/profile")
  // }

  const resetButtonCardBoleans = () => {
    dispatch(setHideCards(false))
  }

  const selectBuildType = (str) => {
    dispatch(setHideCards(true))
    // setCreatorDisplay(str) // legacy
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    resetButtonCardBoleans()
  }, []);

  const options = {
    autoConfig: true,
    debug: false, // enable logs
  };

  useEffect(() => {
    ReactPixel.init('1133510054551065', advancedMatching, options);
    ReactPixel.pageView();
  }, []);

  useEffect(() => {
    dispatch(setFetching(true));
    sessionStorage?.removeItem("prevPath");
    const description = localStorage?.getItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXdescription")
    const jobTitle = localStorage?.getItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXtitle")
    
    
    const populateUser = async () => {
      try {
        //must await
        await checkAuthenticatedUser()
      } catch (error) {
        dispatch(setFetching(false));
        return navigate("/popin?resume");      
      }
      //Get Data if User is Authorized by subscription
      try {
        const response = await axios.get("/user/resume", {
          headers: {
            "x-access-token": isAuth,
          },
        });

        if (response?.data?.status === "unauthenticated") {
          localStorage?.removeItem("token");
          return navigate("/popin?resume");
        }

        const {
          firstName, 
          lastName, 
          profileImg,
          email, 
          mobile,
          sex,
          isFirstTimeUser, 
          jobPosition, 
          stateRegion, 
          country, 
          profSummary,
          resumeSubscriptions,
          resumes, 
          resumeTarget,
          resumeTotalNumbers,
          jobConnectType 
        } = response?.data?.user

        const percentTargetGained = Math.round(resumeTarget.achievedTarget/resumeTarget.setTarget * 100)

        setBubblePoints(percentTargetGained)

        setBasicInfo({
          firstName: firstName,
          lastName: lastName,
          email: email,
          mobile: mobile || "",
          sex: sex || "",
          jobPosition: jobTitle || jobPosition || "",
          city: stateRegion || "",
          country: country || "",
          profSummary: profSummary || "",
        });
        setJobConnectType(jobConnectType || "Hybrid")
        setSexFirstUser(sex || "")
        // console.log(response.data.user);
        dispatch(setUserResumesAll(resumes))
        dispatch(setUserFirstName(firstName))
        dispatch(setProfileImg(profileImg))
        setIsFirstTimeUserPopUp(isFirstTimeUser)
        setSubDuration(resumeSubscriptions?.duration)
        dispatch(setIsResumeSubbed(resumeSubscriptions?.subscribed))
        dispatch(setResumeSubDuration(resumeSubscriptions?.duration))
        dispatch(setResumeServicesNumbers(resumeTotalNumbers))
        dispatch(setUser(response.data.user));
        if(successfulTargetAchievement) {
          openSuccessfulAchievement(true)
          localStorage.removeItem("successfulTargetAchievement")
        }
        if(description) {
          selectBuildType("Optimize");
          setAdditionalInfo(description + `Above is a full job description of the job being applied for, optimize the resume to fit the job description; 
            making sure that keywords from the description appears strategically and professionally in the skills, professional 
            summary and work history of the resultant ATS friendly resume: `)
        }
        dispatch(setFetching(false));
        localStorage?.removeItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXdescription")
        localStorage?.removeItem("ha76arf(**gu9jgkgg8a02bGAKgaigFrSlp08VcgxJG4xXtitle")

      } catch (error) {
        dispatch(setFetching(false));
        errorSetter("Reload page to fetch data")
      }
    };

    populateUser();

  }, [navigate, dispatch, isAuth]);

  useEffect(() => {
    if (!storedResumes.length) {
      if (activeStoredResumeIndex !== 0) {
        setActiveStoredResumeIndex(0);
      }
      setSelectedStoredResume(null);
      setSelectedStoredResumeName('');
      return;
    }
    if (storedResumes.length && activeStoredResumeIndex > storedResumes.length) {
      setActiveStoredResumeIndex(0);
      setSelectedStoredResume(null);
      setSelectedStoredResumeName('');
    }
  }, [storedResumes, activeStoredResumeIndex]);

  //to redirect user if previously unfinished resume
  useEffect(() => {
    const now = Date.now();
    const isResumePresent = localStorage?.getItem(
      "5787378Tgigi879889%%%%7]][][]]]=-9-0d90900io90799CVBcvVVHGGYUYFUYIOUIUTY0I9T]---000789XZJHVB[[[27627787tdtu&3$*))(990-__)((@@"
    );
    const localResume = JSON.parse(isResumePresent);

    if (localResume) {
      if (now > localResume.expiration) {
        // if expired, remove previous resumes in local storage
        localStorage?.removeItem(
          "5787378Tgigi879889%%%%7]][][]]]=-9-0d90900io90799CVBcvVVHGGYUYFUYIOUIUTY0I9T]---000789XZJHVB[[[27627787tdtu&3$*))(990-__)((@@"
        );
        //reload page
        window.location.reload()
      } else {
        confirm({
          title: "Continue Unfinished Resume?",
          description: `You have a previously unfinished Resume, Click Proceed to Continue Editting it or cancel to start new Resume`,
        })
        .then(() => {
          dispatch(setResume(localResume.resumeData));
          navigate("/user/dashboard/resume?preview");
        })
        .catch(() => {
          //remove previous resumes in local storage if expired
          localStorage?.removeItem(
            "5787378Tgigi879889%%%%7]][][]]]=-9-0d90900io90799CVBcvVVHGGYUYFUYIOUIUTY0I9T]---000789XZJHVB[[[27627787tdtu&3$*))(990-__)((@@"
          );
        });
      }

    } 
  }, [confirm, dispatch, navigate])
  

  const [linkInfo, setLinkInfo] = useState([""]);
  const [skills, addSkills] = useState([""]);
  const [interests, addInterests] = useState([""]);
  const [languages, addLanguages] = useState([
    {
      language: "",
      level: ""
    }
  ]);
  const [eduArray, addEduArray] = useState([
    {
      institution: "",
      degree: "",
      date: "",
    },
  ]);
  const [workExpArray, addWorkExpArray] = useState([
    {
      company: "",
      position: "",
      dateFrom: "",
      dateTo: "",
      currently: false,
      industry: "",
      workLink: "",
      workLocation: "",
      jobDesc: "",
    },
  ]);

  const [awardArray, addAwardArray] = useState([
    {
      org: "",
      award: "",
      date: "",
    },
  ]);
  const [publications, addPublications] = useState([
    {
      title: "",
      source: "",
      date: "",
    },
  ]);

  /////////////////FIRST USER FUNCTIONS////////////////////////////////
  const handleDobFirstUserInputChange = event => {
    setDobFirstUser(event.target.value)
  }

  const handleMobileFirstUserInputChange = event => {
    setMobileFirstUser(event?.target?.value ?? event ?? '')
  }

  const handleSexFirstUserInputChange = event => {
    setSexFirstUser(event.target.value)
  }

  const chengeFirstTimeUserStatus = async () => {
    if (basicInfo.country === "") return errorSetter("Choose Country to continue")
    if (basicInfo.city === "") return errorSetter("Choose Region to continue")
    if (sexFirstUser === "") return errorSetter("Choose Sex to continue")
    if (dobFirstUser === "") return errorSetter("Enter Date of Birth to continue")
    if (mobileFirstUser === "") return errorSetter("Enter Mobile Number to continue")
    try {
      //must await
      await checkAuthenticatedUser()
    } catch (error) {
        dispatch(setFetching(false));
        return navigate("/popin?resume");      
    }
    dispatch(setFetching(true))

    const body = {
      dob: dobFirstUser,
      mobile: mobileFirstUser,
      sex: sexFirstUser,
      stateRegion: basicInfo.city,
      country: basicInfo.country
    }
    try {
      const response = await axios.post("/user/update-first-user", body, {
          headers: {
              "x-access-token": isAuth,
          },
      });
      if (response.status === 200) {
        setIsFirstTimeUserPopUp(false)
        const { dob, sex, mobile, country, stateRegion } = response?.data; 
        setBasicInfo(prevState => ({ 
          ...prevState, 
          dob: dob, 
          sex: sex,
          mobile: mobile,
          country: country,
          stateRegion: stateRegion }))
        dispatch(setUser({
          ...user,
          dob: dob,
          sex: sex,
          mobile: mobile,
          country: country,
          stateRegion: stateRegion,
          isFirstTimeUser: false,
        }))
      } else {
        errorSetter("Something went wrong, try again")
      }
      dispatch(setFetching(false))
      return
    } catch (error) {
      dispatch(setFetching(false))
      errorSetter("Something went wrong")
    }
  }


  const toggleResumes = () => {
    setAuthMenuOpen(!authMenuOpen);
  };

  const handleExistingResumeSelect = (idx, resume) => {
    setActiveStoredResumeIndex(idx + 1);
    setSelectedStoredResume(resume || null);
    const resumeName = resume?.storageDetails?.name || resume?.id || `resume_${idx + 1}`;
    setSelectedStoredResumeName(resumeName ? String(resumeName) : '');
    setFile(null);
    setFileError(false);
    try {
      holisticAnalytics.track('ui.feature_used', {
        featureUsed: 'resume_builder',
        eventData: {
          action: 'optimize.resume_select',
          resumeName: resume?.storageDetails?.name || `resume_${idx + 1}`
        }
      });
    } catch (_) {}
  };

  const handleExistingResumePreview = (resume) => {
    if (!resume) {
      errorSetter('Preview unavailable. Please select a different resume.');
      return;
    }
    try {
      holisticAnalytics.track('ui.feature_used', {
        featureUsed: 'resume_builder',
        eventData: {
          action: 'optimize.resume_preview',
          resumeName: resume?.storageDetails?.name
        }
      });
    } catch (_) {}
    setPreviewResume(resume);
    setPreviewModalOpen(true);
  };

  const closeResumePreview = () => {
    setPreviewModalOpen(false);
    setPreviewResume(null);
  };

  //////LINK HANDLERS
  const handleAddLinks = () => {
    const newLink = "";
    if (linkInfo.length < 5) {
      return setLinkInfo([...linkInfo, newLink]);
    }
    errorSetter("You can add a maximum of 5 links")
  };
  const handleDeleteLinks = () => {
    if (linkInfo.length > 1) {
      const prevLinks = [...linkInfo];
      prevLinks.pop();
      return setLinkInfo([...prevLinks]);
    }
    errorSetter("Leave blank, don't delete");
  };
  const handleLinkChange = (event, index) => {
    const prevLinkInfo = [...linkInfo];
    prevLinkInfo[index] = event.target.value;
    setLinkInfo(prevLinkInfo);
  };

  /////////////SKILL HANDLERS
  const handleAddSkill = () => {
    const newSkill = "";
    addSkills([...skills, newSkill]);
  };
  const handleDeleteSkill = () => {
    if (skills.length > 1) {
      const prevSkills = [...skills];
      prevSkills.pop();
      return addSkills([...prevSkills]);
    }
    errorSetter("Leave blank, don't delete");
  };
  const handleSkillChange = (event, index) => {
    const prevSkills = [...skills];
    prevSkills[index] = event.target.value;
    addSkills(prevSkills);
  };

  /////////////SKILL HANDLERS
  const handleAddInterests = () => {
    const newInterest = "";
    addInterests([...interests, newInterest]);
  };
  const handleDeleteInterests = () => {
    if (interests.length > 1) {
      const prevInterests = [...interests];
      prevInterests.pop();
      return addInterests([...prevInterests]);
    }
    errorSetter("Leave blank, don't delete");
  };
  const handleInterestChange = (event, index) => {
    const prevInterests = [...interests];
    prevInterests[index] = event.target.value;
    addInterests(prevInterests);
  };

  ///EDUCATION INFO HANDLERS
  const handleAddEduInfo = () => {
    const newInfo = {
      institution: "",
      degree: "",
      date: "",
    };
    if (eduArray.length < 5) {
      return addEduArray([...eduArray, newInfo]);
    }
    errorSetter("Only add 5 relevant backgrounds");
  };
  const handleDeleteEduInfo = () => {
    if (eduArray.length > 1) {
      const prevInfo = [...eduArray];
      prevInfo.pop();
      return addEduArray([...prevInfo]);
    }
    errorSetter("Leave blank, don't delete");
  };
  const handleEduExpChange = (event, index) => {
    const prevEduExp = [...eduArray];
    switch (event.target.name) {
      case "institution":
        prevEduExp[index].institution = event.target.value;
        addEduArray(prevEduExp);
        break;
      case "degree":
        prevEduExp[index].degree = event.target.value;
        addEduArray(prevEduExp);
        break;
      case "date":
        prevEduExp[index].date = event.target.value;
        addEduArray(prevEduExp);
        break;
      default:
        addEduArray(prevEduExp);
        break;
    }
  };

  /////WORK EXP HANDLERS
  const handleAddExp = () => {
    const newInfo = {
      company: "",
      position: "",
      dateFrom: "",
      dateTo: "",
      currently: false,
      industry: "",
      workLink: "",
      workLocation: "",
      jobDesc: "",
    };
    if (workExpArray.length < 6) {
      return addWorkExpArray([...workExpArray, newInfo]);
    }
    errorSetter("Only add 6 Experiences");
  };
  const handleDeleteExp = () => {
    if (workExpArray.length > 1) {
      const prevInfo = [...workExpArray];
      prevInfo.pop();
      return addWorkExpArray([...prevInfo]);
    }
    errorSetter("Add an Experience, Can't delete");
  };
  const handleWorkExpChange = (event, index) => {
    const prevWorkExp = [...workExpArray];

    switch (event.target.name) {
      case "company":
        prevWorkExp[index].company = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;
      case "position":
        prevWorkExp[index].position = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;
      case "industry":
        prevWorkExp[index].industry = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;
      case "workLink":
        prevWorkExp[index].workLink = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;
      case "workLocation":
        prevWorkExp[index].workLocation = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;
      case "dateFrom":
        prevWorkExp[index].dateFrom = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;
      case "dateTo":
        prevWorkExp[index].dateTo = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;      
      case "currently":
        prevWorkExp[index].currently = !prevWorkExp[index].currently;
        addWorkExpArray(prevWorkExp);
        break;
      case "jobDesc":
        prevWorkExp[index].jobDesc = event.target.value;
        addWorkExpArray(prevWorkExp);
        break;
      default:
        addWorkExpArray(prevWorkExp);
        break;
    }
  };

    /////AWARD HANDLERS
  const handleAddAward = () => {
    const newAward = {
      org: "",
      award: "",
      date: "",
    };
    if (awardArray.length < 10) {
      return addAwardArray([...awardArray, newAward]);
    }
    errorSetter("Only add 10 Awards");
  };
  const handleDeleteAward = () => {
    if (awardArray.length > 1) {
      const prevAward = [...awardArray];
      prevAward.pop();
      return addAwardArray([...prevAward]);
    }
    errorSetter("Leave blank, don't delete");
  };
  const handleAwardChange = (event, index) => {
    const prevAwards = [...awardArray];
    switch (event.target.name) {
      case "org":
        prevAwards[index].org = event.target.value;
        addAwardArray(prevAwards);
        break;
      case "award":
        prevAwards[index].award = event.target.value;
        addAwardArray(prevAwards);
        break;
      case "date":
        prevAwards[index].date = event.target.value;
        addAwardArray(prevAwards);
        break;
      default:
        addAwardArray(prevAwards);
        break;
    }
  };

  /////PUBLICATION HANDLERS
  const handleAddPublication = () => {
    const newPub = {
      title: "",
      source: "",
      date: "",
    };
    if (publications.length < 20) {
      return addPublications([...publications, newPub]);
    }
    errorSetter("Only add 20 Publications");
  };
  const handleDeletePublication = () => {
    if (publications.length > 1) {
      const prevPub = [...publications];
      prevPub.pop();
      return addPublications([...prevPub]);
    }
    errorSetter("Leave blank, don't delete");
  };
  const handlePubChange = (event, index) => {
    const prevPub = [...publications];
      switch (event.target.name) {
      case "title":
        prevPub[index].title = event.target.value;
        addPublications(prevPub);
        break;
      case "source":
        prevPub[index].source = event.target.value;
        addPublications(prevPub);
        break;
      case "date":
        prevPub[index].date = event.target.value;
        addPublications(prevPub);
        break;
      default:
        addPublications(prevPub);
        break;
    }
  };

  ///LANGUAGE HANDLERS
  const handleAddLang = () => {
    const newLang = {
      language: "",
      level: ""
    };
    if (languages.length < 5) {
      return addLanguages([...languages, newLang]);
    }
    errorSetter("5 relevant languages max");
  };
  const handleDeleteLang = () => {
    if (languages.length > 1) {
      const prevLangs = [...languages];
      prevLangs.pop();
      return addLanguages([...prevLangs]);
    }
    errorSetter("Leave blank, don't delete");
  };

  const handleLangChange = (event, index) => {
    const prevLangs = [...languages];
    switch (event.target.name) {
      case "language":
        prevLangs[index].language = event.target.value;
        addLanguages(prevLangs);
        break;
      case "level":
        prevLangs[index].level = event.target.value;
        addLanguages(prevLangs);
        break;
      default:
        addLanguages(prevLangs);
        break;
    }
  };

  const handleJobConnectType = (event) => {
      if (event.target.value === undefined || event.target.value === "") {
        errorSetter("Select a Job Connect Type");
        return;
      }
    setJobConnectType(event.target.value);

    const setConnTypeOnDB = async () => {
      try {
        await axios.post("/user/set-job-connect-type", 
          {jobConnectType: event.target.value}, 
          {
            headers: {
              "x-access-token": isAuth,
            },
          }
        );
        
      } catch (error) {
        console.error("Error setting job connect type:", error);
        errorSetter("Failed to set job connect type");
      }
    }

    setConnTypeOnDB();
  };

  const handleInputChange = (prop) => (event) => {
    //if data is mobile number
    if (prop === "mobile") {
      return setBasicInfo({ ...basicInfo, [prop]: "+" + event });
    }
    if (prop === "country" || prop === "city") {
      setBasicInfo({
        ...basicInfo,
        [prop]: event
      });
      return
    }
    setBasicInfo({
      ...basicInfo,
      [prop]: event.target.value,
    });
  };


  ////SEGMENT VISIBILITY/ANIMATION HANDLERS
  const basicInfoForward = (arg, e) => { 
  if (e) e.preventDefault();
    //check if required fields are filled
    const { mobile, jobPosition, city, country } = basicInfo
    if ( mobile === "") {
      errorSetter("Enter Mobile to continue");
      return;
    }
    if (!jobPosition || jobPosition.trim() === "") {
      errorSetter("Enter Job Position to continue");
      return;
    }
    if (city === "" || city === "State/Region" || country === "" || country === "Country") {
      errorSetter("Choose Country first, then choose State/Region next, to continue");
      return;
    }
  // setBasicFaded(true)
    switch (arg) {
      case "forward":
        // setEduFaded(false)
        break;
    
      default:
        // setEduFaded(false)
        break;
    }
  }

  const eduInfoForwardOrBackward = (arg, e) => { 
  if (e) e.preventDefault();  
  // setEduFaded(true)
    switch (arg) {
      case "forward":
        //check if required fields are filled
        if (checkEmptyStringsInObjNoExempt(eduArray) === false ) {
          // setEduFaded(false)
          return errorSetter("Complete required fields in this section to continue");    
        }
        // setWorkFaded(false)
        break;
      case "backward":
        // setBasicFaded(false);
        break;
    
      default:
        
        break;
    }
  }

  const workExpForwardOrBackward = (arg, e) => { 
  if (e) e.preventDefault();
  // setWorkFaded(true)
    switch (arg) {
      case "forward":
        //check if required fields are filled, exempting some keys
        if (checkEmptyStringsInObj(workExpArray, "jobDesc", "workLink", "dateTo", "currently", "workLocation") === false ) {
          // setWorkFaded(false)
          errorSetter("Complete required fields in this section to continue");
          return;
        }
        // setSkillFaded(false)
        break;
      case "backward":
        // setEduFaded(false)
        break;
    
      default:
        break;
    }
  }

  const skillsForwardOrBackward = (arg, e) => { 
  if (e) e.preventDefault();
  // setSkillFaded(true)
    switch (arg) {
      case "forward":
        //check if required fields are filled, exempting two keys
        if (checkEmptyStrings(skills) === false ) {
          // setSkillFaded(false)
          errorSetter("Complete required fields in this section to continue");
          return;
        }
        // setCertFaded(false)
        break;
      case "backward":
        // setWorkFaded(false)
        break;
    
      default:
        break;
    }
  }

  const certsForwardOrBackward = (arg, e) => { 
  if (e) e.preventDefault();
  // setCertFaded(true)
    switch (arg) {
      case "forward":
        // setPubFaded(false)
        break;
      case "backward":
        // setSkillFaded(false)
        break;
    
      default:
        break;
    }
  }

  const pubForwardOrBackward = (arg, e) => { 
  if (e) e.preventDefault();
  // setPubFaded(true)
    switch (arg) {
      case "forward":
        // setLangFaded(false)
        break;
      case "backward":
        // setCertFaded(false)
        break;
    
      default:
        break;
    }
  }

  const langForwardOrBackward = (arg, e) => {
  if (e) e.preventDefault();

  // setLangFaded(true)
    switch (arg) {
      case "forward":
          if (!languages || languages.length === 0 || languages.every(lang => !lang.language || lang.language.trim() === "")) {
            errorSetter("Add at least one language to continue");
            return;
          }
        // setInterestFaded(false)
        const sb = document.getElementById("submit-button"); if (sb) sb.style.display = "";
        break;
      case "backward":
        // setPubFaded(false)
        break;
    
      default:
        break;
    }
  }

  const interestsBackward = (arg, e) => { 
  if (e) e.preventDefault();
  // setInterestFaded(true)
    switch (arg) {
      case "backward":
  // setLangFaded(false)
  const sb2 = document.getElementById("submit-button"); if (sb2) sb2.style.display = "none";
        break;
    
      default:
        break;
    }
  }



  ///////DRAG AND DROP & FILE FUNCTIONS
  const handleUploadFile = (e) => {
    try { if (e && typeof e.preventDefault === 'function') e.preventDefault(); } catch(_) {}
    try { if (e && typeof e.stopPropagation === 'function') e.stopPropagation(); } catch(_) {}
    setFileError(false);
    setActiveStoredResumeIndex(0);
    setSelectedStoredResume(null);
    setSelectedStoredResumeName('');
    const MAX_FILE_SIZE = 14 * 1024 * 1024;
    const allowedTypes = ['.doc', '.docx', '.pdf', '.txt'];

    let selectedFile;
    if (e.type === "drop") {
      selectedFile = e.dataTransfer.files[0];
    } else {
      selectedFile = e.target.files[0];
    }

    if (!selectedFile) {
      errorSetter("No file detected");
      setFileError(true);
      return;
    }

    const fileExtension = selectedFile.name.toLowerCase().split('.').pop();
    if (!allowedTypes.includes(`.${fileExtension}`)) {
      errorSetter("Please drop only PDF, DOC, or TXT files.");
      setFileError(true);
      return;
    }

    if (selectedFile.size > MAX_FILE_SIZE) {
      errorSetter(`"${selectedFile.name}" exceeds the maximum file size of ${MAX_FILE_SIZE / (1024 * 1024)} MB.`);
      setFileError(true);
      return;
    }

    setFile(selectedFile);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleUploadFile(e)
  };

  const clearManualUpload = () => {
    setFile(null);
    setFileError(false);
    setActiveStoredResumeIndex(0);
    setSelectedStoredResume(null);
    setSelectedStoredResumeName('');
    try {
      if (dragDropRef.current) {
        dragDropRef.current.value = null;
      }
    } catch (_) {}
  };

  const handleFileResumeOptimize = async (options = {}) => {
  if (options.e) options.e.preventDefault();
  if (options.e) options.e.preventDefault();
    const needsGuidance = Boolean(options.needsGuidance);
    const guidanceInterests = typeof options.guidanceInterests === 'string' ? options.guidanceInterests.trim() : '';
    try {
      //must await
      await checkAuthenticatedUser()
    } catch (error) {
      return navigate("/popin?resume");      
    }
    const hasManualUpload = Boolean(file);
    const hasStoredSelection = Boolean(selectedStoredResume);
    if (!hasManualUpload && !hasStoredSelection) {
      errorSetter("Upload or select a resume to continue")
      return
    }
    if (!needsGuidance && !basicInfo.jobPosition) {
      errorSetter("Input Job Position")
      return
    }

    if (needsGuidance && !guidanceInterests) {
      errorSetter("Share at least one interest or hobby so I can guide you")
      return
    }

    if (!basicInfo.country) {
      errorSetter("Choose Country first, then choose State/Region next, to continue")
      return
    }
    if (!basicInfo.city) {
      errorSetter("Choose Country first, then choose State/Region next, to continue")
      return
    }

    const formData = new FormData();
    // attach uploaded resume file OR stored resume reference and relevant fields
    if (hasManualUpload) {
      formData.append('file', file);
    } else if (hasStoredSelection) {
      const storedName = selectedStoredResumeName || selectedStoredResume?.storageDetails?.name || '';
      if (storedName) {
        formData.append('storedResumeName', storedName);
      }
      const storedId = selectedStoredResume?._id || selectedStoredResume?.id;
      if (storedId) {
        formData.append('storedResumeId', storedId);
      }
    }
    formData.append('firstName', basicInfo.firstName || '');
    formData.append('city', basicInfo.city || '');
    formData.append('country', basicInfo.country || '');
    formData.append('jobPosition', basicInfo.jobPosition || '');
    formData.append('jobConnectType', jobConnectType || '');
    formData.append('additionalInfo', additionalInfo || '');
    formData.append('needsCareerGuidance', needsGuidance ? 'true' : 'false');
    if (needsGuidance) {
      formData.append('guidanceInterests', guidanceInterests);
    }
    if (addlInfoImageFiles.length > 0) {
      addlInfoImageFiles.forEach(f => formData.append('images', f));
    }
    //get event progress
  const eventSource = new EventSource(`/user/progress${isAuth ? `?token=${encodeURIComponent(isAuth)}` : ''}`);
    //listen for SSE (progress + completion)
    let awaitingJobId = null;
    eventSource.onmessage = (event) =>  {
      try {
        const progressUpdate = JSON.parse(event.data);
        // progress payloads (only for our job)
        if (progressUpdate && progressUpdate.type === 'resumeJobProgress') {
          // if server emits progress before we get POST ack, capture jobId
          if (!awaitingJobId && progressUpdate.jobId) {
            awaitingJobId = progressUpdate.jobId;
          }
          if (
            typeof progressUpdate.percent === 'number' &&
            progressUpdate.status &&
            (!awaitingJobId || (progressUpdate.jobId && progressUpdate.jobId === awaitingJobId))
          ) {
            setProgressPercentage(progressUpdate.percent);
            setProgressStatus(progressUpdate.status);
          }
        }
        // completion payload
        if (
          progressUpdate &&
          progressUpdate.type === 'resumeJobDone' &&
          ((progressUpdate.jobId && awaitingJobId && progressUpdate.jobId === awaitingJobId) || !awaitingJobId)
        ) {
          const dataObject = progressUpdate.result?.resumeData;
          const remoteRoadmap = progressUpdate.result?.careerRoadmap;
          if (!dataObject && !remoteRoadmap) return; // safety
          // Convert the string to a JavaScript object (if present)
          const myObject = dataObject ? (new Function(`return (${dataObject})`))() : null;
          try { holisticAnalytics.track('resume.optimized', { featureUsed: 'resume_builder' }); } catch(_) {}
          const now = new Date().getTime();
          let resumeObjforLocal = { resumeData: myObject, expiration: now + 168 * 60 * 60 * 1000 };
          try {
            localStorage.setItem(RESUME_LOCAL_KEY, JSON.stringify(resumeObjforLocal));
            // cache career roadmap if present in generated resume
            try {
                const roadmapFromResume = myObject?.careerRoadmap || (myObject?.seniority && myObject.seniority.careerRoadmap);
                const roadmap = remoteRoadmap || roadmapFromResume;
                if (roadmap) setCareerRoadmapCache(roadmap);
            } catch (_) {}
          } catch (_) {}
          setLoading(false);
          eventSource.close();
          clearAddlInfoImages();
          navigate("/user/dashboard/resume?preview");
        }
        // failure payload
        if (
          progressUpdate &&
          progressUpdate.type === 'resumeJobFailed' &&
          ((progressUpdate.jobId && awaitingJobId && progressUpdate.jobId === awaitingJobId) || !awaitingJobId)
        ) {
          eventSource.close();
          setLoading(false);
          errorSetter(progressUpdate.error || 'Failed to optimize resume');
        }
      } catch (_) {}
    };

    try {
      setLoading(true);
      dispatch(setResume({}));
      const response = await axios.post(
        "/user/optimize-uploaded-resume",
        formData,
        {
          headers: {
            "x-access-token": isAuth,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status === 500) {
        setLoading(false);
        errorSetter("So many people currently querying Bubble Ai, try again");
        return
      }
      if (response?.data?.status === 'processing' && response?.data?.jobId) {
        awaitingJobId = response.data.jobId;
        // keep loader until SSE completion
      } else if (response?.data?.resumeData) {
        // backward compatibility
        const dataObject = response.data.resumeData;
        const remoteRoadmap = response.data.careerRoadmap || null;
        const myObject = dataObject ? (new Function(`return (${dataObject})`))() : null;
        try { holisticAnalytics.track('resume.optimized', { featureUsed: 'resume_builder' }); } catch(_) {}
        const now = new Date().getTime();
        let resumeObjforLocal = { resumeData: myObject, expiration: now + CACHE_TTL_MS };
        try {
          localStorage.setItem(RESUME_LOCAL_KEY, JSON.stringify(resumeObjforLocal));
          try {
            const roadmapFromResume = myObject?.careerRoadmap || (myObject?.seniority && myObject.seniority.careerRoadmap);
            const roadmap = remoteRoadmap || roadmapFromResume;
            if (roadmap) setCareerRoadmapCache(roadmap);
          } catch (_) {}
        } catch (_) {}
        setLoading(false);
        eventSource.close();
        clearAddlInfoImages();
        navigate("/user/dashboard/resume?preview");
      }
    } catch (error) {
      setLoading(false);
      errorSetter("So many people currently querying Bubble Ai, try again");
      try { holisticAnalytics.track('resume.optimization_failed', { featureUsed: 'resume_builder', errorMessage: error?.message }); } catch(_) {}
      eventSource.close();
      clearAddlInfoImages();
    }
  }


  const navigateToCreateStep = (stepNumber) => {
      document.dispatchEvent(new CustomEvent("navToCreateStep", { detail: { step: stepNumber } }));
  };

  const handleCreateFromScratch = async (e) => {
      if (e) e.preventDefault();
      
      if (!basicInfo.jobPosition || !basicInfo.jobPosition.trim()) {
        errorSetter("Fill job position to continue");
        navigateToCreateStep(1);
        return;
      }
      if (!basicInfo.country || !basicInfo.city || basicInfo.city === "State/Region" || basicInfo.country === "Country") {
        errorSetter("Choose Country first, then choose State/Region next, to continue");
        navigateToCreateStep(1);
        return;
      }
      if (!jobConnectType) {
        errorSetter("Select Job Connect Type to continue");
        navigateToCreateStep(1);
        return;
      }
      
      if (checkEmptyStringsInObjNoExempt(eduArray) === false ) {
         errorSetter("Complete required fields in Education section to continue");
         navigateToCreateStep(2);
         return;
      }

      if (checkEmptyStringsInObj(workExpArray, "jobDesc", "workLink", "dateTo", "currently", "workLocation") === false ) {
          errorSetter("Complete required fields in Experience section to continue");
          navigateToCreateStep(3);
          return;
      }

      if (checkEmptyStrings(skills) === false ) {
          errorSetter("Complete required fields in Skills section to continue");
          navigateToCreateStep(4);
          return;
      }

      if (!languages || languages.length === 0 || languages.every(lang => !lang.language || lang.language.trim() === "")) {
          errorSetter("Add at least one language to continue");
          navigateToCreateStep(7);
          return;
      }
      if (checkEmptyStringsInObj(languages) === false) {
          errorSetter("Complete required fields in Languages section to continue");
          navigateToCreateStep(7);
          return;
      }

      if (checkEmptyStrings(interests) === false ) {
          errorSetter("Complete required fields in Hobbies section to continue");
          navigateToCreateStep(8);
          return;
      }

      setLoading(true);
    dispatch(setResume({}));
    const resumeData = {
      basicInfo: basicInfo, //Object
      linkInfo: linkInfo, //Array
      skills: skills, //Array
      interests: interests, //Array
      eduArray: eduArray, //Array
      workExpArray: workExpArray, //Array
      awardArray: awardArray, //Array
      publications: publications, //Array
      languages: languages, //Array
    };

    //get event progress
    const eventSource = new EventSource(`/user/progress${isAuth ? `?token=${encodeURIComponent(isAuth)}` : ''}`);
    let awaitingJobId = null;
    //listen for SSE (progress + completion)
    eventSource.onmessage = (event) =>  {
      try {
        const progressUpdate = JSON.parse(event.data)
        if (
          progressUpdate && progressUpdate.type === 'resumeJobProgress' &&
          progressUpdate.jobId && awaitingJobId && progressUpdate.jobId === awaitingJobId &&
          typeof progressUpdate.percent === 'number' && progressUpdate.status
        ) {
          setProgressPercentage(progressUpdate.percent);
          setProgressStatus(progressUpdate.status)
        }
        if (progressUpdate && progressUpdate.type === 'resumeJobDone' && progressUpdate.jobId && awaitingJobId && progressUpdate.jobId === awaitingJobId) {
            const now = new Date().getTime();
            let resumeObjforLocal = {
              resumeData: progressUpdate.result?.resumeData,
              expiration: now + CACHE_TTL_MS,
            };
          try {
            localStorage.setItem(RESUME_LOCAL_KEY, JSON.stringify(resumeObjforLocal));
            // progressUpdate.result?.resumeData may be string or object; attempt to normalize
            try {
              let hydrated = resumeObjforLocal.resumeData;
              if (typeof hydrated === 'string') {
                try { hydrated = new Function(`return (${hydrated})`)(); } catch (_) { try { hydrated = JSON.parse(hydrated); } catch (_) { hydrated = null; } }
              }
                const remoteRoadmap = progressUpdate.result?.careerRoadmap || null;
                const roadmapFromResume = hydrated?.careerRoadmap || (hydrated?.seniority && hydrated.seniority.careerRoadmap);
                const roadmap = remoteRoadmap || roadmapFromResume;
                if (roadmap) setCareerRoadmapCache(roadmap);
            } catch (_) {}
          } catch (_) {}
          try { holisticAnalytics.track('resume.created', { featureUsed: 'resume_builder' }); } catch(_) {}
          setLoading(false);
          eventSource.close();
          navigate("/user/dashboard/resume?preview");
        }
        if (progressUpdate && progressUpdate.type === 'resumeJobFailed' && progressUpdate.jobId && awaitingJobId && progressUpdate.jobId === awaitingJobId) {
          eventSource.close();
          setLoading(false);
          errorSetter(progressUpdate.error || 'Failed to create resume');
        }
      } catch(e) {
        errorSetter('Something happened, try again');
      }
    };

    try {
  const response = await axios.post("/user/customize-resume", resumeData, {
        headers: {
          "x-access-token": isAuth,
        },
      });
      if (response.status === 500) {
        setLoading(false);
        errorSetter("Throttling, try again after a while");
        return
      }

      if (response?.data?.status === 'processing' && response?.data?.jobId) {
        awaitingJobId = response.data.jobId;
        // continue listening for SSE done
      } else if (response?.data?.resumeData) {
        const now = new Date().getTime();
        let resumeObjforLocal = {
          resumeData: response.data.resumeData,
          expiration: now + CACHE_TTL_MS,
        };
        try {
          localStorage.setItem(RESUME_LOCAL_KEY, JSON.stringify(resumeObjforLocal));
          try {
            let hydrated = resumeObjforLocal.resumeData;
            if (typeof hydrated === 'string') {
              try { hydrated = new Function(`return (${hydrated})`)(); } catch (_) { try { hydrated = JSON.parse(hydrated); } catch (_) { hydrated = null; } }
            }
            const roadmap = hydrated?.careerRoadmap || (hydrated?.seniority && hydrated.seniority.careerRoadmap);
            if (roadmap) setCareerRoadmapCache(roadmap);
          } catch (_) {}
        } catch (_) {}
        try { holisticAnalytics.track('resume.created', { featureUsed: 'resume_builder' }); } catch(_) {}
        setLoading(false);
        eventSource.close();
        navigate("/user/dashboard/resume?preview");
      }
    } catch (error) {
      setLoading(false);
      errorSetter("Throttling, try again after a while");
  try { holisticAnalytics.track('error_occurred', { featureUsed: 'resume_builder', errorMessage: error?.message, eventData: { action: 'resume_create_from_scratch' } }); } catch(_) {}
      eventSource.close();
    }
  };

  // Additional Info image paste/upload handlers
  useEffect(() => {
    const handlePaste = (e) => {
      try {
        const items = e.clipboardData && e.clipboardData.items;
        if (!items) return;
        const maxBytes = 10 * 1024 * 1024;
        for (let i = 0; i < items.length; i++) {
          const it = items[i];
          if (it.type && it.type.indexOf('image') !== -1) {
            const blob = it.getAsFile();
            if (!blob) continue;
            if (blob.size > maxBytes) { errorSetter('Image larger than 10MB'); continue; }
            if (addlInfoImageFiles.length >= 5) { errorSetter('Maximum 5 images allowed'); return; }
            const url = URL.createObjectURL(blob);
            setAddlInfoImagePreviews(prev => [...prev, url].slice(0,5));
            setAddlInfoImageFiles(prev => [...prev, blob].slice(0,5));
          }
        }
      } catch(_) {}
    };
    window.addEventListener('paste', handlePaste);
    return () => {
      window.removeEventListener('paste', handlePaste);
      addlInfoImagePreviews.forEach(u => { try { URL.revokeObjectURL(u); } catch(_) {} });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addlInfoImagePreviews, addlInfoImageFiles.length, errorSetter]);

  const handleAddlInfoFileSelect = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const maxBytes = 10 * 1024 * 1024;
    const newPreviews = [];
    const newFiles = [];
    for (const f of files) {
      if (!f.type.startsWith('image/')) continue;
      if (f.size > maxBytes) { errorSetter('Image larger than 10MB'); continue; }
      if ((addlInfoImageFiles.length + newFiles.length) >= 5) { errorSetter('Maximum 5 images allowed'); break; }
      const url = URL.createObjectURL(f);
      newPreviews.push(url);
      newFiles.push(f);
    }
    if (newFiles.length > 0) {
      setAddlInfoImagePreviews(prev => [...prev, ...newPreviews].slice(0,5));
      setAddlInfoImageFiles(prev => [...prev, ...newFiles].slice(0,5));
    }
    e.target.value = null;
  };

  const triggerAddlInfoSelect = (e) => {
    // prevent form submission and bubbling when clicking upload inside a form
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    if (addlInfoFileInputRef.current) addlInfoFileInputRef.current.click();
  };

  const removeSingleAddlInfoImage = (idx, e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    setAddlInfoImagePreviews(prev => {
      const copy = [...prev];
      const [removed] = copy.splice(idx,1);
      try { if (removed) URL.revokeObjectURL(removed); } catch(_) {}
      return copy;
    });
    setAddlInfoImageFiles(prev => {
      const copy = [...prev];
      copy.splice(idx,1);
      return copy;
    });
  };

  const clearAddlInfoImages = () => {
    addlInfoImagePreviews.forEach(u => { try { URL.revokeObjectURL(u); } catch(_) {} });
    setAddlInfoImagePreviews([]);
    setAddlInfoImageFiles([]);
  };


  return (
    <div className="auth-container content">
      {/* For SIDE MENU */}
      <AuthSideMenu
        opened={authMenuOpen}
        hidden={!authMenuOpen}
        resumeSubDuration={subDuration}
        isResumeSubbed={isResumeSubbed}
        arrayDetails={userResumesAll}
      />

      <BubbleFloat />
  <UpgradePopup />
      
      <div className="auth-container-inner">
        {/* for TOP MENU */}
        <AuthHeader
          authMenuOpen={authMenuOpen}
          onClick={toggleResumes}
          headerText="Create Resume"
        />

        <DataContainer
            bubblePoints={bubblePoints}
            DragDropHandleDrop={handleDrop}
            DragDropRef={dragDropRef}
            DragDropFileError={fileError}
            DragDropFile={file}
            DragDropHandleUploadFile={handleUploadFile}
            clearManualUpload={clearManualUpload}
            optimizeBasicInfo={basicInfo}
            optimizeHandleInputChange={handleInputChange}
            optimizeJobConnectType={jobConnectType}
            optimizeJobTypesArray={jobTypesArray}
            optimizeHandleJobConnectType={handleJobConnectType}
            optimizeSetAdditionalInfo={setAdditionalInfo}
            optimizeAdditionalInfo={additionalInfo}
            handleFileResumeOptimize={handleFileResumeOptimize}
            onSubmitCreate={handleCreateFromScratch}
            addlInfoImagePreviews={addlInfoImagePreviews}
            addlInfoFileInputRef={addlInfoFileInputRef}
            triggerAddlInfoSelect={triggerAddlInfoSelect}
            handleAddlInfoFileSelect={handleAddlInfoFileSelect}
            removeSingleAddlInfoImage={removeSingleAddlInfoImage}
            basicLinkInfo={linkInfo}
            basicHandleAddLinks={handleAddLinks}
            basicHandleDeleteLinks={handleDeleteLinks}
            basicHandleLinkChange={handleLinkChange}
            eduArray={eduArray}
            handleEduExpChange={handleEduExpChange}
            handleDeleteEduInfo={handleDeleteEduInfo}
            handleAddEduInfo={handleAddEduInfo}
            workExpArray={workExpArray}
            handleWorkExpChange={handleWorkExpChange}
            handleDeleteExp={handleDeleteExp}
            handleAddExp={handleAddExp}
            skills={skills}
            handleSkillChange={handleSkillChange}
            handleDeleteSkill={handleDeleteSkill}
            handleAddSkill={handleAddSkill}
            awardArray={awardArray}
            handleAwardChange={handleAwardChange}
            handleDeleteAward={handleDeleteAward}
            handleAddAward={handleAddAward}
            publications={publications}
            handlePubChange={handlePubChange}
            handleDeletePublication={handleDeletePublication}
            handleAddPublication={handleAddPublication}
            languages={languages}
            handleLangChange={handleLangChange}
            languageStore={LANGUAGES}
            langLevelsArray={langLevelsArray}
            handleDeleteLang={handleDeleteLang}
            handleAddLang={handleAddLang}
            interests={interests}
            setInterestsArray={addInterests}
            handleInterestChange={handleInterestChange}
            handleDeleteInterests={handleDeleteInterests}
            handleAddInterests={handleAddInterests}
            basicInfoForward={basicInfoForward}
            eduInfoForwardOrBackward={eduInfoForwardOrBackward}
            workExpForwardOrBackward={workExpForwardOrBackward}
            skillsForwardOrBackward={skillsForwardOrBackward}
            certsForwardOrBackward={certsForwardOrBackward}
            pubForwardOrBackward={pubForwardOrBackward}
            langForwardOrBackward={langForwardOrBackward}
            interestsBackward={interestsBackward}
            existingResumes={storedResumes}
            existingResumeSelectedIndex={activeStoredResumeIndex}
            onExistingResumeSelect={handleExistingResumeSelect}
            onExistingResumePreview={handleExistingResumePreview}
            storedResumeSelected={Boolean(selectedStoredResume)}
            selectedStoredResumeName={selectedStoredResumeName}
        
        />
      </div>

      {loading && (
        <Modal
          header4={`Hello ${user.firstName}`}
          header3={progressStatus}
          progress={progressPercentage}
        />
      )}


      {isFirstTimeUserPopUp  && (
          <PlainModalOverlay>
            <h2>Welcome {basicInfo.firstName}!</h2>
            <p>Kindly fill out the following, and I'll get you started</p>
            <div style={{ width: "100%", marginBottom: "1rem" }}>
              <div className={resumeCss.DetachedLabels} style={{color: '#EE7B1C'}}>
                Country* : (will be used to connect you to jobs so choose a country with remote jobs if remote is your preference.) You can always change this in your profile.
              </div>
            </div>
            <AuthInput
              id={"basicInfo.country"}
              name={basicInfo.country}
              value={basicInfo.country}
              inputType="country-select"
              inputGridSm={12}
              inputGrid={3}
              mb={2}
              onChange={handleInputChange("country")}
            />
            <AuthInput
              country={basicInfo.country}
              id={"basicInfo.city"}
              name={basicInfo.city}
              value={basicInfo.city}
              inputType="state-select"
              inputGridSm={12}
              inputGrid={3}
              mb={2}
              onChange={handleInputChange("city")}
            />
            <div style={{ width: "100%" }}>
              <div className={resumeCss.DetachedLabels}>
                Choose Sex *
              </div>
            </div>
            <AuthInput
              id={"sexFirstUser"}
              name={sexFirstUser}
              value={sexFirstUser}
              inputType="select2"
              list={sexOptions}
              inputGridSm={12}
              inputGrid={3}
              mb={2}
              required={true}
              onChange={handleSexFirstUserInputChange}
            />
            <div style={{ width: "100%" }}>
              <div className={resumeCss.DetachedLabels}>
                Date of Birth *
              </div>
            </div>
            <AuthInput
              id={"dobFirstUser"}
              value={dobFirstUser}
              placeholder="Date of Birth"
              inputType="date"
              inputGridSm={12}
              inputGrid={3}
              mb={2}
              required={true}
              onChange={event => handleDobFirstUserInputChange(event)}
            />

            <div style={{ width: "100%" }}>
              <div className={resumeCss.DetachedLabels}>
                Your Phone Number *
              </div>
            </div>
            <AuthInput
              id={"mobileFirstUser"}
              value={mobileFirstUser}
              label="Mobile"
              inputType="mobile"
              inputGridSm={12}
              inputGrid={4}
              mb={2}
              required={true}
              onChange={handleMobileFirstUserInputChange}
            /> 
            <div style={{width: "100%", padding: "0 30%", marginTop: "2rem"}}>
              <ButtonSubmitGreen type="button" onClick={() => chengeFirstTimeUserStatus()}>
                Continue
              </ButtonSubmitGreen>  
            </div>        
          </PlainModalOverlay>
      )}

      {successfulAchievement && 
          <SuccessFailureModal 
              success={successfulAchievement} 
              successText="Congratulations, You have been rewarded!"
              bodyText="You received Bubble Points! keep using Bubble Ai to reach your target and EARN an extra week/month of access, Good luck!"
              buttonText="Claim Points Reward"
              fullName={user.firstName} 
          /> 
      }

      <ResumePreviewModal
        open={previewModalOpen}
        resume={previewResume}
        onClose={closeResumePreview}
        zIndex={1200000}
      />

    </div>
  );
};

export default memo(CustomizeResume);
